<template>
    <hts-drawer
        v-model="cVisible"
        size="90%"
        :title="drawerTitle"
        :loading="loading"
        @show="init">
        <div class="p-3 grid grid-cols-3 gap-4">
            <div>
                <div class="flex flex-col gap-2">
                    <p class="text-2xl text-main-600">
                        {{ $t('labels.status') }}
                    </p>

                    <status
                        :status="journey.status"
                        module="journeyStatus"
                        key-status="status"
                        label="" />
                </div>
            </div>

            <div>
                <p class="text-2xl text-main-600">
                    {{ $t('labels.route') }}
                </p>
                <ul
                    v-if="journey.stages && journey.stages.length"
                    class="steps steps-vertical w-full">
                    <li
                        v-for="(item, index) in (journey.stages as any[])"
                        :key="index"
                        data-content=" "
                        class="step float w-full">
                        <div class="flex items-center justify-center w-full">
                            <div
                                class="items-center w-full text-left"
                                :class="{
                                    'py-4': index !== 0
                                }">
                                <p class="font-bold">
                                    {{ item.fullNameNode }}
                                </p>
                                <p
                                    v-if="item.locationName"
                                    class="pt-1">
                                    {{ item.locationName }}
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div>
                <p class="text-2xl text-main-600">
                    {{ $t('labels.otherInformation') }}
                </p>
                <p class="font-bold mt-2">
                    {{ $t('labels.commodity') }}
                </p>
                <p class="mb-2">
                    <span class="text-no first-letter:capitalize">
                        {{ dataOrder.commodityCategory }}
                    </span>
                    <span v-if="dataOrder.commodityCategory">
                        :
                    </span>
                    <span class="first-letter:capitalize">
                        {{ dataOrder.commodityName }}
                    </span>
                    <span v-if="dataOrder.goodsStatusName">
                        -
                    </span>
                    <span class="first-letter:capitalize">
                        {{ dataOrder.goodsStatusName }}
                    </span>
                </p>

                <template v-if="dataOrder.transportation === 'NON_CONTAINER'">
                    <p class="font-bold mt-2">
                        {{ $t('labels.vehicleType') }}
                    </p>
                    <p class="mb-2">
                        {{ dataOrder.vehicleCategoryName }}
                    </p>
                </template>
                <template v-else>
                    <p class="font-bold mt-2">
                        {{ $t('labels.containerType') }}
                    </p>
                    <p class="mb-2">
                        <span>
                            {{ dataOrder.contCategory }} feet
                        </span>
                        <span v-if="dataOrder.headContainer || dataOrder.mergeContainer">
                            - {{ dataOrder.headContainer ? `${$t('labels.headContainer')}` : '' }}{{ dataOrder.headContainer && dataOrder.mergeContainer ? ',' : ''
                            }}{{ dataOrder.mergeContainer ? `${$t('labels.mergeContainer')} ` : '' }}
                        </span>
                    </p>
                </template>

                <p class="font-bold mt-2">
                    {{ $t('labels.productivity') }}
                </p>
                <p class="mb-2">
                    {{ $formatters.formatNumber(dataOrder.productivityOrder || 0) }}
                    {{ dataOrder.transportation === 'NON_CONTAINER' ? $t('labels.vehicle') : $t('labels.container') }}
                </p>
            </div>
        </div>

        <template v-if="true">
            <div
                v-if="!loading"
                class="mx-5 mb-20">
                <hts-ui-tabs
                    v-model="tapSelected"
                    :tabs="tabs"
                    :exclude="exclude">
                    <template #default="{ key, label }: any">
                        <div class="relative">
                            {{ label }}
                            <template v-if="key === 'driver-notifications' && hasDriverAlert">
                                <span class="absolute text-sm -top-2 -right-6 text-white bg-error-500 font-medium border px-2 rounded-full">
                                    {{ hasDriverAlert }}
                                </span>
                            </template>
                            <template v-if="key === 'alerts' && hasAlert">
                                <span class="absolute text-sm -top-2 -right-6 text-white bg-error-500 font-medium border px-2 rounded-full">
                                    {{ hasAlert }}
                                </span>
                            </template>
                        </div>
                    </template>
                </hts-ui-tabs>
                <div
                    v-show="tapSelected === 'plan'"
                    class="py-1">
                    <travel-detail
                        v-if="journey.travelDetails"
                        ref="travelDetail"
                        :journey="journey"
                        @ourney-changed="handleChange" />
                </div>

                <div v-show="tapSelected === 'prices'">
                    <info-prices
                        ref="tabPrices"
                        :journey="journey"
                        @modified="handleChange" />
                </div>
            </div>
        </template>
        <div
            v-else
            class="text-center text-3xl font-medium text-error-500 border border-error-500 px-2 py-1 rounded-md">
            Chặng không có thời gian bắt đầu hoặc thời gian kết thúc
        </div>
    </hts-drawer>
</template>
<script lang="ts" setup>
import InfoPrices from './journey-info/prices.vue'
import TravelDetail from './journey-info/travel-detail.vue'
import Status from '~/components/status.vue'
const { $event, $formatters } = useNuxtApp()
const props = defineProps({
  api: {
    type: Object,
    required: true
  },
  exclude: {
    type: Array as PropType<any[]>,
    default: () => []
  },
  travelExclude: {
    type: Array as PropType<any[]>,
    default: () => []
  }
})

const { api } = toRefs(props)

const loading = ref(true)
const cVisible = ref(false)
const monitoringHeight = ref(0)
const monitoring = ref()
const tapSelected = ref('plan')

const tabs = ref([
  { key: 'plan', label: $t('labels.plan'), permission: true }
  // { key: 'prices', label: $t('labels.prices'), permission: checkPermission(['monitoring_journey_pricing_view']) }
])
const drawerTitle = computed(() => `Thông tin chặng #${journey.code}`)
const journey = reactive<any>({
  _id: '',
  code: '',
  stages: [],
  stageNames: [],
  timeIn: null,
  timeOut: null,
  vehicleId: null,
  vehicleTempId: null,
  order: {},
  alerts: [],
  stageIndexStart: 0,
  stageIndexEnd: 0,
  trip: null
})

const journeyId = ref<string | null>(null)
const dataOrder = computed<any>(() => journey?.order || {})
const alerts = computed(() => (journey.alerts || []).filter((a: any) => !a.skipped && !a.resolved))
const hasAlert = computed(() => Array.isArray(alerts.value) && alerts.value.length)
const driverAlerts = computed(() => (journey.driverAlerts || []).filter((a: any) => !a.skipped && !a.resolved))
const hasDriverAlert = computed(() => Array.isArray(driverAlerts.value) && driverAlerts.value.length)
const tabFile = ref<any>(null)
const tabActivity = ref<any>(null)
const tabAlert = ref<any>(null)
const tabDriverNotification = ref<any>(null)
const tabPlanning = ref<any>(null)
const tabPlanningActual = ref<any>(null)

const getJourney = (silence: boolean = false) => {
  if (!silence) {
    loading.value = true
  }
  $api(api.value, { uriParams: { ID: journeyId.value } }).then(({ data }: any) => {
    const temp = (data?.value || {}).data || {}

    Object.assign(journey, temp)
    nextTick(() => {
      if (!silence) {
        loading.value = false
      }
    })
  })
}

const init = () => {
  getJourney()
}

const show = (id: string) => {
  Object.assign(journey, {
    _id: '',
    code: '',
    stages: [],
    stageNames: [],
    timeIn: null,
    timeOut: null,
    vehicleId: null,
    vehicleTempId: null,
    order: {}
  })
  journeyId.value = id
  cVisible.value = true
  setJourneyRead()
  eventListening()
}

const hide = () => {
  cVisible.value = false
}
const refresh = (id?: string) => {
  if (!cVisible.value) {
    return
  }
  if (id && journeyId.value !== id) {
    return
  }

  getJourney(true)
  tabAlert.value && tabAlert.value.refresh()
  tabDriverNotification.value && tabDriverNotification.value.refresh()
  tabFile.value && tabFile.value.refresh()
  tabActivity.value && tabActivity.value.refresh()
  tabPlanning.value && tabPlanning.value.refresh()
  tabPlanningActual.value && tabPlanningActual.value.refresh()
}

const setJourneyRead = () => {
  if (!journeyId.value) {
    return
  }
  $api($url.monitoring.journey.read, { uriParams: { ID: journeyId.value } })
}

const handleChange = $lodash.debounce(() => {
  refresh()
}, 300)

defineExpose({ show, hide, refresh })
const company = computed(() => $store().system.getCompany)

const eventListening = () => {
  $event.listen(`c-${company.value._id}-${journeyId.value}-journey-change`, (event: any) => {
    refresh()
  })
}

watch(
  () => tapSelected.value,
  (val) => {
    if (val === 'monitoring') {
      setMonitoringHeight()
    }
  }
)

const setMonitoringHeight = () => {
  nextTick(() => {
    // console.log('monitoring')
    monitoringHeight.value = monitoring.value.clientHeight
  })
}

const tripRoute = computed(() => {
  return {
    name: 'trucker-id-trip',
    query: { id: journey.trip }
  }
})
onUnmounted(() => {
  $event.unsubscribe(`c-${company.value._id}-${journeyId.value}-journey-change`, () => {})
})
</script>
